import * as React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

function SvgLeaves(props) {
	return (
		<SvgIcon {...props}>
			<g
				stroke="currentColor"
				strokeWidth={1.2}
				fill="none"
				fillRule="evenodd"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M12 3.5V7M17.464 5.489l-2.25 2.68M20.37 10.524l-3.446.607M19.361 16.25L16.33 14.5M14.907 19.987L13.71 16.7M9.093 19.987L10.29 16.7M4.639 16.25L7.67 14.5M3.63 10.524l3.446.607M6.536 5.489l2.25 2.68" />
			</g>
		</SvgIcon>
	)
}

export default SvgLeaves
